import React from "react";
import { Chip, Tooltip } from "..";
import { ChipProps } from "../Chip/Chip.types";
import {
  prepareChipLabel,
  prepareTooltipTitle,
} from "./ChipWithTooltip.helpers";
interface ChipWithTooltipProps extends ChipProps {
  maxVisibleChars?: number;
  label?: string;
}

function ChipWithTooltip(props: ChipWithTooltipProps) {
  const { maxVisibleChars, label, ...other } = props;
  const title = prepareTooltipTitle(label, maxVisibleChars);
  const chipLabel = prepareChipLabel(label, maxVisibleChars);
  if (title === "") {
    return <Chip {...other} label={chipLabel} />;
  }
  return (
    <Tooltip title={title}>
      <Chip {...other} label={chipLabel} />
    </Tooltip>
  );
}

export default ChipWithTooltip;
